import { SERVER_API } from "../../Constant";
import axios from "axios";

// Fetch GRN List
export const FetchGRNList_api = async (
  page: number,
  limit: number,
  search: string,
) => {
  try {
    const response = await axios.get(`${SERVER_API}/GRN/fetch_grn_list.php`, {
      params: { page, limit, search },
    });
    return response.data;
  } catch (error) {
    console.error("Fetch GRN list failed:", error);
    return { error: "Fetch GRN list failed" };
  }
};

// Fetch GRN Items
export const FetchGRNItems_api = async (grnId: number) => {
  try {
    const response = await axios.get(`${SERVER_API}/GRN/fetch_grn_items.php`, {
      params: { grn_id: grnId },
    });
    return response.data;
  } catch (error) {
    console.error("Fetch GRN items failed:", error);
    return { error: "Fetch GRN items failed" };
  }
};

// Add GRN - Updated to send product_id instead of product_has_stock_id
export const AddGRN_api = async (inputs: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(inputs));

    const response = await axios.post(
      `${SERVER_API}/GRN/add_grn.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Add GRN failed:", error);
    return { error: "Add GRN failed" };
  }
};
